import { Fragment, h } from 'preact'; /** @jsx h */
import { useState, useEffect } from 'preact/hooks';

export const RowWrapper = props => {
    // wrap this around elements if you want several in the same line
    return (
        <div className={`flexRow${props.className ? ` ${props.className}` : ''}`}>
            {props.children}
        </div>
    );
};

export const FormPage = props => {
    return <fieldset className={`formPage ${props.className || ''}`}>{props.children}</fieldset>;
};

export const Form = props => {
    return (
        <form {...props} data-matomo-mask>
            <p className="mandatory-mark-info">
                <span className="bigger">*</span> - merket felt må fylles ut.
            </p>
            {props.children}
        </form>
    );
};

export const MultiplePageHandler = props => {
    const [activeStep, setActiveStep] = useState(0);
    const [submitWaiting, setSubmitWaiting] = useState(false);

    const updateStep = (step, e) => {
        setActiveStep(step);
        const form = document.getElementById(props.formId);

        if (form) {
            const pages = form.getElementsByClassName('formPage');
            const y = pages[step].getElementsByTagName('input');

            if (y.length > 0) {
                // vent 250 ms før fokus settes for å fungere i alle nettlesere
                setTimeout(() => y[0].focus(), 250);
            }
        }
        e.preventDefault();
    };
    const validatePage = addClass => {
        const form = document.getElementById(props.formId);
        if (form) {
            const pages = form.getElementsByClassName('formPage');
            if (pages.length > 0 && pages.length > activeStep - 1) {
                const y = pages[activeStep].getElementsByTagName('input');
                let i;
                for (i = 0; i < y.length; i++) {
                    if (!y[i].checkValidity()) {
                        if (addClass) y[i].classList.add('isInvalid');
                        return false;
                    }
                }
            }
        }
        return true;
    };
    const onSubmitClick = (stepNo, e) => {
        setSubmitWaiting(true);
        if (stepNo + 1 < props.pageArr.length) {
            if (stepNo >= 0) {
                if (validatePage(true)) {
                    const step = props.pageArr[stepNo];
                    const hasNextStep = stepNo + 1 < props.pageArr.length;

                    if (step && 'nextFunction' in step) {
                        props.pageArr[stepNo]
                            .nextFunction()
                            .then(response => {
                                if (response && hasNextStep) {
                                    updateStep(stepNo + 1, e);
                                }
                            })
                            .catch(e => {
                                // filter out Ingen støtttemedlemsdata errors
                                if (e.message !== 'Ingen støttemedlemsdata') {
                                    throw e;
                                }
                            });
                    } else if (hasNextStep) {
                        updateStep(stepNo + 1, e);
                    }
                }
            }
            e.preventDefault();
        }
        setSubmitWaiting(false);
    };

    const showBackBtn = activeStep > 0;

    return (
        <Fragment>
            {props &&
                props.pageArr &&
                props.pageArr.map((page, ind) => {
                    return (
                        <>
                            <FormPage
                                key={ind}
                                stepBtn={page.stepBtn}
                                className={activeStep === ind ? 'activeStep' : ''}
                            >
                                {page.content}
                                <div
                                    className={
                                        'button-wrapper top-high' +
                                        (showBackBtn ? ' button-wrapper-back' : '') +
                                        (page.alternateRoute ? ' multiple-buttons' : '')
                                    }
                                >
                                    {page.stepBtn ? (
                                        page.stepBtn
                                    ) : (
                                        <button
                                            type="submit"
                                            className={`submitBtn${
                                                submitWaiting ? ' waiting' : ''
                                            }`}
                                            onClick={e => onSubmitClick(activeStep, e)}
                                            disabled={submitWaiting}
                                        >
                                            {page.btnTxt ||
                                                (ind + 1 === props.pageArr.length
                                                    ? 'Send'
                                                    : 'Neste')}
                                        </button>
                                    )}
                                    {page.alternateRoute && page.alternateRoute}
                                    {showBackBtn && (
                                        <button
                                            type="button"
                                            className={`back-btn`}
                                            onClick={e => updateStep(activeStep - 1, e)}
                                        >
                                            Tilbake
                                        </button>
                                    )}
                                </div>
                            </FormPage>
                        </>
                    );
                })}
        </Fragment>
    );
};

export const MultipleStepHandler = ({ pageArr, formRef, updateStepEvent, forceToStep }) => {
    const [activeStep, setActiveStep] = useState(0);
    const [submitWaiting, setSubmitWaiting] = useState(false);

    useEffect(() => {
        if (forceToStep) {
            const indOfStep = pageArr.findIndex(stp => stp.name === forceToStep);
            if (indOfStep >= 0 && activeStep !== indOfStep) setActiveStep(indOfStep);
        }
    }, [forceToStep]);

    const updateStep = (step, e) => {
        setActiveStep(step);
        const form = formRef.current.base;

        if (form) {
            const pages = form.getElementsByClassName('formPage');

            if (pages.length > step) {
                const y = pages[step].getElementsByTagName('input');

                if (y.length > 0) {
                    // vent 250 ms før fokus settes for å fungere i alle nettlesere
                    setTimeout(() => y[0].focus(), 250);
                }
            }
        }
        e.preventDefault();
        updateStepEvent(step);
    };

    const validatePage = addClass => {
        const form = formRef.current.base;

        if (form) {
            const pages = form.getElementsByClassName('formPage');
            if (pages.length > 0 && pages.length > activeStep - 1) {
                const y = pages[activeStep].getElementsByTagName('input');
                let i;
                for (i = 0; i < y.length; i++) {
                    if (!y[i].checkValidity()) {
                        if (addClass) y[i].classList.add('isInvalid');
                        return false;
                    }
                }
            }
        }
        return true;
    };

    const onSubmitClick = (stepNo, e) => {
        setSubmitWaiting(true);
        if (stepNo + 1 < pageArr.length) {
            if (stepNo >= 0) {
                if (validatePage(true)) {
                    const step = pageArr[stepNo];
                    const hasNextStep = stepNo + 1 < pageArr.length;

                    if (step && 'nextFunction' in step) {
                        pageArr[stepNo]
                            .nextFunction()
                            .then(response => {
                                if (response && hasNextStep) {
                                    updateStep(stepNo + 1, e);
                                }
                            })
                            .catch(e => {
                                // filter out Ingen støtttemedlemsdata errors
                                if (e.message !== 'Ingen støttemedlemsdata') {
                                    throw e;
                                }
                            });
                    } else if (hasNextStep) {
                        updateStep(stepNo + 1, e);
                    }
                }
            }
            e.preventDefault();
        }
        setSubmitWaiting(false);
    };

    const showBackBtn = activeStep > 0;

    const disableBtn = disableNext => {
        if (submitWaiting) return true;
        else if (disableNext) return true;
        return false;
    };

    return (
        <Fragment>
            {pageArr &&
                pageArr.map((page, ind) => {
                    if (!page) {
                        return null;
                    }

                    return (
                        <FormPage
                            key={page.name}
                            stepBtn={page.stepBtn}
                            className={activeStep === ind ? 'activeStep' : ''}
                        >
                            {pageArr.length > 1 && ind !== 0 && (
                                <p className="formStepper">
                                    Steg {ind + 1}/{pageArr.length}
                                </p>
                            )}
                            {page.content}
                            <div
                                className={
                                    'button-wrapper top-high' +
                                    (showBackBtn ? ' button-wrapper-back' : '') +
                                    (page.alternateRoute ? ' multiple-buttons' : '')
                                }
                            >
                                {page.stepBtn ? (
                                    page.stepBtn
                                ) : (
                                    <button
                                        type="submit"
                                        className={`submitBtn${submitWaiting ? ' waiting' : ''}`}
                                        onClick={e => onSubmitClick(activeStep, e)}
                                        disabled={disableBtn(page.disableNext)}
                                    >
                                        {page.btnTxt ||
                                            (ind + 1 === pageArr.length ? 'Send' : 'Neste')}
                                    </button>
                                )}
                                {page.alternateRoute && page.alternateRoute}
                                {showBackBtn && (
                                    <button
                                        type="button"
                                        className={`back-btn`}
                                        onClick={e => updateStep(activeStep - 1, e)}
                                    >
                                        Tilbake
                                    </button>
                                )}
                            </div>
                        </FormPage>
                    );
                })}
        </Fragment>
    );
};
